import { upsertSuggestions, upsertSuggestion } from 'redux/actions/suggestions'
import { PaginationParams } from 'types'
import { Store } from 'redux'
import { SuggestionsClient } from 'api/clients/SuggestionsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

interface ShowOptions {
  autoAcknowledgeTransition: boolean
  userId?: string | null
}

export const SuggestionsService = {
  index: async (store: Store, articleKey: string, options: PaginationParams) => {
    const res = await SuggestionsClient.index(articleKey, options)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertSuggestions(res.data.suggestions))
    }

    return res
  },

  show: async (store: Store, id: number, options?: ShowOptions) => {
    const res = await SuggestionsClient.show(id, options?.userId)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(
        upsertSuggestion({
          ...res.data.suggestion,
          acknowledged_last_transition: !!options?.autoAcknowledgeTransition
            ? true
            : res.data.suggestion.acknowledged_last_transition,
        }),
      )
    }

    return res
  },

  create: async (store: Store, articleKey: string, branch_title?: string) => {
    const res = await SuggestionsClient.create(articleKey, undefined, branch_title)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertSuggestion(res.data.suggestion))
    }

    return res
  },
}
